var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendfunds({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33594 10.1668C6.33594 10.8135 6.83595 11.3335 7.44928 11.3335H8.7026C9.23593 11.3335 9.66927 10.8802 9.66927 10.3135C9.66927 9.70682 9.40261 9.48682 9.00928 9.34682L7.0026 8.64682C6.60927 8.50682 6.34261 8.29349 6.34261 7.68016C6.34261 7.12016 6.77593 6.66016 7.30927 6.66016H8.5626C9.17594 6.66016 9.67594 7.18016 9.67594 7.82682",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V12",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6693 8.99992C14.6693 12.6799 11.6826 15.6666 8.0026 15.6666C4.3226 15.6666 1.33594 12.6799 1.33594 8.99992C1.33594 5.31992 4.3226 2.33325 8.0026 2.33325",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.99992V2.33325H12",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 5.66659L14.6693 2.33325",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendfunds);
export default __webpack_public_path__ + "static/media/sendfunds.f6303db76f7d46d83f21d73e3debfa3d.svg";
export { ForwardRef as ReactComponent };